import React, { FC } from "react";

import { IgHeaderWTooltip, IgPaper, IgTypography } from "@intelligems/ig-theme";
import { Divider, Grid, SvgIcon, SvgIconTypeMap } from "@mui/material";
import { OverridableComponent } from "@mui/types";

import theme from "../../../../theme";

interface MetricChipProps {
  title: string;
  tooltip: string;
  icon: OverridableComponent<SvgIconTypeMap> & { muiName: string };
  value1: string;
  value2: string | undefined;
  footerText: string | undefined;
}

export const MetricChip: FC<MetricChipProps> = ({
  title,
  tooltip,
  value1,
  value2,
  icon,
  footerText,
}) => {
  return (
    <IgPaper
      sx={{
        boxShadow: "none",
        padding: "20px 40px 20px 40px",
        // height: "100px",
        [theme.breakpoints.down("md")]: {
          height: "120px",
        },
      }}
    >
      <Grid container direction={"column"}>
        <Grid item container direction={"row"} alignItems={"center"} xs>
          <Grid item>
            <SvgIcon
              sx={{ marginRight: "10px" }}
              viewBox={"0 0 36 23"}
              component={icon}
            />
          </Grid>
          <Grid item>
            <IgHeaderWTooltip sectionTitle={title} tooltipMessage={tooltip} />
          </Grid>
        </Grid>

        <Grid
          item
          container
          direction={"row"}
          columnSpacing={1}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Grid item>
            <IgTypography
              sx={{
                fontSize: "36px",
                [theme.breakpoints.down("lg")]: {
                  fontSize: "25px",
                },
                paddingLeft: "33px",
                fontWeight: 600,
              }}
            >
              {value1}
            </IgTypography>
          </Grid>
          {value2 && (
            <>
              <Grid item>
                <Divider sx={{ height: "39px" }} orientation={"vertical"} />
              </Grid>
              <Grid item>
                <IgTypography
                  sx={{
                    fontSize: "36px",
                    [theme.breakpoints.down("lg")]: {
                      fontSize: "25px",
                    },
                    fontWeight: 600,
                  }}
                >
                  {value2}
                </IgTypography>
              </Grid>
              <Grid item />
            </>
          )}
        </Grid>

        <Grid item sx={{ marginLeft: "33px", minHeight: "24px" }}>
          {footerText && (
            <IgTypography
              sx={{
                letterSpacing: "1%",
                fontSize: "12px",
                textTransform: "uppercase",
              }}
            >
              {footerText}
            </IgTypography>
          )}
        </Grid>
      </Grid>
    </IgPaper>
  );
};
